import { baseSeriesMark } from "../base/constant";

export const heatmapSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    cell: {
        name: "cell",
        type: "cell"
    },
    cellBackground: {
        name: "cellBackground",
        type: "cell"
    }
});
//# sourceMappingURL=constant.js.map
